import { createSelector } from 'reselect';
import { subselect } from './root';
import { propertiesSelector } from './properties';

const apiParamsSelector = createSelector(
  [propertiesSelector],
  ({ ID }) =>
    ID && {
      sid: ID,
    },
);

export const playbackSessionApiParamsSelector = subselect(apiParamsSelector);
